// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2B3VR","alert":"SettungsInbox_alert__hFoDG"};